/** VS Code Emmet `!` expansion — HTML5 boilerplate. */
export const HTML5_BOILERPLATE = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    
</body>
</html>`;

export function isWebPreviewLanguage(language) {
  const lang = String(language || '').toLowerCase();
  return lang === 'html' || lang === 'css';
}

/**
 * Open the current HTML document in a new browser tab.
 * Uses an <a target="_blank"> click first (more reliable than window.open
 * against popup blockers), then falls back to window.open.
 * Returns { url } so the UI can show a manual link if opening is blocked.
 */
export function openHtmlInBrowser(html) {
  const doc = String(html || '');
  const blob = new Blob([doc], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  // Keep blob alive long enough for the new tab to load.
  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);

  return { url };
}

/**
 * Build a document string suitable for iframe srcDoc / new-tab preview.
 * No script injection — keeps the browser's native right-click menu.
 */
export function buildPreviewHtml(language, code) {
  const lang = String(language || '').toLowerCase();
  const source = String(code ?? '');

  if (lang === 'css') {
    return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>CSS Preview</title>
    <style>
${source}
    </style>
</head>
<body>
    <h1>Heading 1</h1>
    <h2>Heading 2</h2>
    <p>This is a sample paragraph for CSS preview.</p>
    <button type="button">Button</button>
    <div class="box">.box</div>
    <ul>
        <li>List item 1</li>
        <li>List item 2</li>
    </ul>
</body>
</html>`;
  }

  if (!source.trim()) {
    return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Preview</title>
</head>
<body>
    <p style="font-family: system-ui; color: #666; padding: 1rem;">
      Type HTML (or press <kbd>!</kbd> then <kbd>Tab</kbd> for a starter) and click Preview.
    </p>
</body>
</html>`;
  }

  return source;
}
